<template>
    <v-autocomplete
        v-model="model"
        :items="internalItems"
        :search-input.sync="search"
        hide-no-data
        item-text="title"
        item-value="_id"
        label="Select Course Resources"
        placeholder="Start typing to search Course Resources"
        ariaRequired=true
        prepend-icon="mdi-clipboard-multiple"
        color="primary"
        flat="flat"
        :solo=true
        multiple="multiple"
        chips
        :loading="isLoading"
        return-object
        :allow-overflow=false
    >
      <!-- The dropdown list part -->

      <v-divider />

      <template
          v-slot:item="data"
      >
        <template
            class="my-15"
            v-if="data.item.type == 'scorm'">

          <v-list-item-avatar>
            <v-icon large>
              mdi-folder-zip
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
              <v-list-item-title
                  class="font-weight-bold"
              >
                {{ data.item.title}}
              </v-list-item-title>

            <v-row>
              <v-col
                  v-if="data.item.status"
                  cols="1">
                <v-chip class="subtitle-2 font-weight-light">
                  {{ data.item.status }}
                </v-chip>
              </v-col>

              <v-col>
                <div class="font-weight-medium primary--text">
                  Scorm ID:

                  <span class="subtitle-2 font-weight-light black--text">
                    {{ data.item.courseId }}
                  </span>
                </div>
              </v-col>
            </v-row>

          </v-list-item-content>
        </template>

        <template v-else>
          <v-list-item-avatar>
            <v-icon large>
              mdi-play-circle
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>

            <v-list-item-title
                class="font-weight-bold"
            >
              {{ data.item.title}}
            </v-list-item-title>

            <p class="subtitle-2 font-weight-light">{{data.item.description}}</p>
          </v-list-item-content>
        </template>
      </template>
      <!-- End the dropdown list part -->

      <!-- The selected part -->
      <template
          v-slot:selection="data"
      >
        <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            class="hidden"
        >
        </v-chip>
      </template>

    </v-autocomplete>
</template>

<script>
import axios from "axios";

export default {
  name: "Resources",
  data() {
    return {
      model: null,
      isLoading: false,
      search: null,
      entries: [],
    };
  },
  methods: {
    itemWithType(item) {
      item.type = item.originalName ? 'scorm' : 'video';
      return item;
    },
    remove(item) {
      for (let [index, value] of this.model.entries()) {
        if(value._id == item._id) {
          this.model.splice(index, 1);
          break;
        }
      }
    },
  },
  computed: {
    internalItems() {
      return this.entries.map(entry => {
        //TODO - Tidy this up
        //It will do for now as we only have two resource types
        const title = entry.title ? entry.title : entry.originalName;
        entry = this.itemWithType(entry);
        return Object.assign({}, entry, {title: title});
      });
    },
  },
  mounted() {
    const newEntries = [];
    this.items.forEach(function(item) {
      newEntries.push(item.data);
    });

    this.model = newEntries;
  },
  watch: {
    items(items) {

      if(!this.model || items.length === this.model.length) {
        return;
      }

      const newEntries = [];
      items.forEach(function(item) {
        newEntries.push(item.data);
      });

      this.model = newEntries;

    },
    model(model) {

      const formattedResources = [];

      for(let resource of model) {

        resource = this.itemWithType(resource);
        const pojo = Object.assign({}, resource);

        switch(resource.type) {

          case 'video':

            delete pojo.type;

            formattedResources.push({
              type: 'video',
              data: pojo,
            });
            break;

          case 'scorm':

            delete pojo.title;
            delete pojo.type;

            formattedResources.push({
              type: 'scorm',
              data: pojo,
            });
            break;

        }

      }

      this.update(formattedResources);
    },
    search(val) {

      // Items have already been requested
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      let component = this;

      const scormURI = `${process.env.VUE_APP_SERVICE_URI_SCORM}/api/courses/?originalName=/${val}/i&limit=5&page=1`;
      const videoURI = `${process.env.VUE_APP_SERVICE_URI_VIDEO}/api/vimeo-youtube/?description=/${val}/i&limit=5&page=1`;

      const requestScorm = axios.get(scormURI);
      const requestVideo = axios.get(videoURI);

      axios.all([requestScorm, requestVideo]).then(axios.spread((...responses) => {

        const entries = [];

        responses.forEach(function(response) {
          entries.push(...response.data.docs);
        });

        component.entries = entries;

      })).catch(() => {
        //// TODO handle error later
      }).finally(function () {
        // always executed
        component.isLoading = false;
      });
    },
  },
  props: {
    update: {
      type: Function,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>